import { Treeselect } from "@riophae/vue-treeselect";
import InputGroup from "@@/core/components/product/shared/InputGroup/InputGroup";
import { BFormCheckbox, BFormInput } from "bootstrap-vue";

export default {
  name: "ProductPublishing",
  components: {
    InputGroup,
    Treeselect,
    BFormCheckbox,
    BFormInput,
  },
  props: {
    value: Object,
    submit: Function,
    disabled: Boolean,
    edit: Object,
    mode: String,
  },
  mounted() {
    this.realValue.update_updated_at = true;
    console.log(this.mode, "this.mode");
    console.log(this.edit.published_at, "this.edit.published_at");

    if (this.mode == "edit" && this.edit.published_at) {
      console.log(this.realValue.scheduling);

      this.realValue.scheduling = true;
    }
    console.log(this.realValue.scheduling, "this.realValue.scheduling");
  },
  data() {
    return {
      statusOptions: [
        {
          id: "available",
          label: "موجود",
        },
        {
          id: "soon",
          label: "بزودی",
        },
        {
          id: "presale",
          label: "پیش فروش",
        },
        {
          id: "out_of_stock",
          label: "ناموجود",
        },
        {
          id: "draft",
          label: "پیش نویس",
        },
        {
          id: "redirect",
          label: "ری دایرکت",
        },
      ],
      realValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.realValue = newVal;
    },
    realValue(newVal) {
      this.$emit("input", newVal);
    },
  },
};
